import { useMutation } from '@tanstack/react-query';

import { sharedApi } from '../../apis/shared.api';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface UseUploadYieldMapParams {}

export function useUploadYieldMap() {
  return useMutation({
    mutationFn: sharedApi.uploadYieldMap,
  });
}

export default useUploadYieldMap;
